import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import { ApplicationConfigService } from 'src/app/core/config/application-config.service';
import { TempRequestService } from 'src/app/core/services/temp-request.service';
import { DynamicMenuService } from 'src/app/admin/dynamic-menu/dynamic-menu.service';
import { CommonService } from 'src/app/shared/services/common.service';

import { MockDb } from '../mock-db';

const MOCK_LATENCY_MS = 300;

/**
 * Stands in for DynamicMenuService when `environment.useMock` is true.
 * Serves the per-role tree from contracts-1 §2.4 / §2.5.
 *
 * Note the `{ body: ... }` wrapper: the real call uses `{ observe: 'response' }`, and
 * LoginComponent reads `res.body.responseCode` / `res.body.data`.
 */
@Injectable()
export class MockDynamicMenuService extends DynamicMenuService {
  constructor(
    http: HttpClient,
    commonService: CommonService,
    applicationConfigService: ApplicationConfigService,
    tempRequestService: TempRequestService,
  ) {
    super(http, commonService, applicationConfigService, tempRequestService);
  }

  override assignedMenus(): Observable<any> {
    MockDb.ensureSeeded();
    const user = MockDb.getCurrentUser();
    const data = user ? MockDb.menusFor(user.role) : [];

    return of({
      body: {
        responseCode: 'S100000',
        responseMessage: 'Operation successful',
        data,
      },
    }).pipe(delay(MOCK_LATENCY_MS));
  }
}
